import { FULL_APRON, POLO_SHIRT, WAIST_APRON } from "./shirt_parts";

export const product_list = [POLO_SHIRT, FULL_APRON, WAIST_APRON];
